import { __decorate } from "tslib";
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ActionButton from '@/components/action_button/Index.vue';
import DialogStateMixin from '@/helpers/vue_mixins/v2/DialogStateMixin';
import CheckVoucherCode from '@/components/v2/store_add_ons/CheckVoucherCode';
import VoucherBySerialIdQuery from '@/plugins/graphql/queries/v2/store_add_ons/voucher-by-serial-id.gql';
import { VoucherRebateModel } from '@/helpers/entities/models/VoucherRebateModel';
import { Mutation, Getter } from 'vuex-class';
import { ConsoleLogger } from '@/helpers/entities/classes/logger/ConsoleLogger';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import _ from 'lodash';
var VoucherStatuses;
(function (VoucherStatuses) {
    VoucherStatuses["Available"] = "available";
    VoucherStatuses["BotRedeemed"] = "bot_redeemed";
})(VoucherStatuses || (VoucherStatuses = {}));
let RedeemVoucherDialog = class RedeemVoucherDialog extends Mixins(ViewportSizeMixin, DialogStateMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.voucherCode = '';
        this.voucherExist = false;
        this.icon = '';
        this.color = '';
        this.voucherBySerialId = {};
        this.voucherAdded = false;
    }
    voucherInput(voucher) {
        this.voucherCode = _.toUpper(voucher);
    }
    get textFieldIcon() {
        if (this.voucherExist) {
            return 'check';
        }
        return '';
    }
    get textFieldColor() {
        if (this.voucherExist) {
            return 'green';
        }
        return '';
    }
    closeDialog() {
        const vm = this;
        vm.$refs.search.clearableCallback();
        this.icon = '';
        this.color = '';
        this.toggle = false;
        this.voucherExist = false;
    }
    toggleConfirmation() {
        this.toggle = !this.toggle;
    }
    onSubmit() {
        const vm = this;
        if (this.voucherBySerialId && this.voucherExist && !this.addMoreVoucher) {
            if (vm.storeVouchers.includes(vm.voucherBySerialId.uuid)) {
                this.errorNotification('Voucher already added');
            }
            else {
                this.updateVouchers(vm.voucherBySerialId.uuid);
                vm.$refs.search.clearableCallback();
                this.$router.push('create');
                this.icon = '';
                this.color = '';
                this.voucherExist = false;
            }
        }
        if (this.addMoreVoucher) {
            if (vm.storeVouchers.includes(vm.voucherBySerialId.uuid)) {
                this.errorNotification('Voucher already added');
            }
            else {
                this.updateVouchers(vm.voucherBySerialId.uuid);
                this.toggle = false;
                vm.$refs.search.clearableCallback();
                this.icon = '';
                this.color = '';
                this.voucherExist = false;
            }
        }
    }
    checkVoucherIfExist() {
        if (Object.keys(this.voucherBySerialId).length > 0) {
            this.voucherExist = true;
        }
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], RedeemVoucherDialog.prototype, "addMoreVoucher", void 0);
__decorate([
    Getter('vouchers', { namespace: 'vouchers' })
], RedeemVoucherDialog.prototype, "storeVouchers", void 0);
__decorate([
    Mutation('updateVouchers', { namespace: 'vouchers' })
], RedeemVoucherDialog.prototype, "updateVouchers", void 0);
__decorate([
    Watch('voucherBySerialId')
], RedeemVoucherDialog.prototype, "checkVoucherIfExist", null);
RedeemVoucherDialog = __decorate([
    Component({
        components: {
            CheckVoucherCode,
            ActionButton,
        },
        apollo: {
            voucherBySerialId: {
                query: VoucherBySerialIdQuery,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return {
                        serialId: this.voucherCode,
                        statuses: [VoucherStatuses.Available, VoucherStatuses.BotRedeemed],
                    };
                },
                update(data) {
                    try {
                        return new VoucherRebateModel(data.voucherBySerialId);
                    }
                    catch (e) {
                        const vm = this;
                        const logger = new ConsoleLogger();
                        logger.info(e.message);
                        vm.voucherExist = false;
                    }
                },
            },
        },
    })
], RedeemVoucherDialog);
export default RedeemVoucherDialog;
